import type { QueryKey, UseQueryOptions } from '@tanstack/react-query'
import type { ApiError } from 'utils'
import type { ZodError } from 'zod'

/**
 * Wrapper for the first argument of `useQuery` that provides convenient type inference,
 * in cases where you want to share the same query object across multiple use* hooks.
 */
export function toQuery<
  TQueryFnData,
  TError = ZodError | ApiError,
  TData = TQueryFnData,
  TQueryKey extends QueryKey = QueryKey
>(
  options: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>
): UseQueryOptions<TQueryFnData, TError, TData, TQueryKey> {
  return options
}
